import { Textarea } from '@/components/common/Textarea';

interface AccessPointMetadataPartial {
  type?: 'access_point';
  accessNotes?: string;
}

interface AccessPointFormProps {
  metadata: AccessPointMetadataPartial;
  onChange: (updated: AccessPointMetadataPartial) => void;
}

export function AccessPointForm({ metadata, onChange }: AccessPointFormProps) {
  return (
    <div className="flex flex-col gap-4">
      <Textarea
        id="access-notes"
        label="Access Notes"
        value={metadata.accessNotes ?? ''}
        onChange={(v) => onChange({ ...metadata, accessNotes: v || undefined })}
        placeholder="Gate codes, parking details, access notes..."
        rows={4}
      />
    </div>
  );
}
